import React, { useState } from "react";
import { IconButton, MenuItem, Tooltip } from "@mui/material";
import { Language, Check } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import MenuPopup from "../../layout/MenuPopup";

const languages = [
  { code: "en", label: "English", flag: "🇺🇸" },
  { code: "ar", label: "العربية", flag: "🇸🇦" },
];

const LanguageSwitcher = ({ light = false }) => {
  const { i18n, t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);

  const currentLang =
    languages.find((l) => l.code === i18n.language) || languages[0];

  const handleClick = (e) => {
    setAnchorEl(e.currentTarget);
  };

  const handleChange = (code) => {
    i18n.changeLanguage(code);
  };

  return (
    <>
      <Tooltip title={t("language")}>
        <IconButton
          onClick={handleClick}
          size="small"
          className={
            light
              ? "!border !border-slate-300 !rounded-lg !px-2 !py-1 !gap-1.5 hover:!bg-slate-100"
              : "!border !border-white/40 !rounded-lg !px-2 !py-1 !gap-1.5 hover:!bg-white/10"
          }
        >
          <Language className={`!text-[20px] ${light ? "!text-slate-600" : "!text-white"}`} />
          <span className={`text-[12px] font-semibold leading-none ${light ? "text-slate-600" : "text-white"}`}>
            {currentLang.code.toUpperCase()}
          </span>
        </IconButton>
      </Tooltip>
      <MenuPopup
        id="language-menu"
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {languages.map((lang) => {
          const isActive = i18n.language === lang.code;
          return (
            <MenuItem
              key={lang.code}
              onClick={() => handleChange(lang.code)}
              className={`!min-w-[160px] !gap-3 !py-2.5 ${
                isActive ? "!bg-primary-50" : ""
              }`}
            >
              <span className="text-[20px] leading-none">{lang.flag}</span>
              <span
                className={`flex-1 text-[14px] ${
                  isActive
                    ? "font-semibold text-primary"
                    : "font-normal text-gray-700"
                }`}
              >
                {lang.label}
              </span>
              {isActive && (
                <Check className="!text-[18px] !text-primary" />
              )}
            </MenuItem>
          );
        })}
      </MenuPopup>
    </>
  );
};

export default LanguageSwitcher;
